import Domain from "./domain";
export default {
  methods: {
    getAttendanceCount: async function(attendanceType, rangeType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            `customer/dashboard/attendance/count?date_range=${rangeType}&attendance_type=${attendanceType}`,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getEmergencyCount: async function(rangeType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            `customer/dashboard/emergency/count?date_range=${rangeType}`,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getGroupAttendanceCount: async function(attendanceType, rangeType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            `customer/dashboard/group/count?date_range=${rangeType}&attendance_type=${attendanceType}`,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getResourcesCount: async function(attendanceType, rangeType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            `customer/dashboard/resources/count?date_range=${rangeType}&attendance_type=${attendanceType}`,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getAssetsCount: async function(attendanceType, rangeType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            `customer/dashboard/assets/count?date_range=${rangeType}&attendance_type=${attendanceType}`,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
